import type { ReactElement } from 'react';
import { useNavigate } from 'react-router';
import { BasicInfoForm, useCreateProduct } from '@/features/catalog';
import { PageHeader } from '@/shared/ui';
import { ProductSetupSteps } from './product-setup-steps';

/**
 * 신규 등록 화면 — 기본 정보 완성 시 DRAFT 를 만들고 수정 화면으로 넘어간다.
 * 넓은 화면은 두 칸: 왼쪽 기본 정보 카드, 오른쪽 등록 순서 안내(화면에 붙는다).
 */
export const NewProductView = (): ReactElement => {
  const navigate = useNavigate();
  const createAction = useCreateProduct();

  return (
    <>
      <PageHeader
        title="상품 등록"
        description="기본 정보를 저장하면 등록 중(DRAFT) 상품이 만들어지고, 이어서 섹션별로 채웁니다."
      />

      <div className="grid items-start gap-6 lg:grid-cols-[minmax(0,1fr)_320px]">
        <div className="rounded-2xl border border-foreground/[0.06] bg-card p-6 shadow-[0_1px_2px_rgba(0,0,0,0.03)] sm:p-8">
          {createAction.error ? (
            <p
              role="alert"
              className="mb-6 rounded-xl bg-red-50 px-4 py-3 text-sm text-destructive"
            >
              {createAction.error.message}
            </p>
          ) : null}

          <BasicInfoForm
            submitLabel="상품 만들기"
            isSubmitting={createAction.isPending}
            onSubmit={(values) => {
              void createAction
                .createProduct(values)
                .then((created) => navigate(`/products/editor/${created.id}`))
                .catch(() => undefined);
            }}
          />
        </div>

        <ProductSetupSteps done={[false, false, false, false, false, false]} />
      </div>
    </>
  );
};
